import { IUAD } from '@publishing-engine/domain/models';
import ReportCard from './ReportCard';
type ReportEntriesListProps = {
  entries: (IUAD & {
    title?: string;
    risk?: string;
  })[];
};
const ReportEntriesList = ({ entries }: ReportEntriesListProps) => {
  return (
    <>
      {entries.map(entry => {
        return (
          <>
            <ReportCard UADEntry={entry} />
          </>
        );
      })}
    </>
  );
};

export default ReportEntriesList;
